<!-- Footer -->
<!-- <p class="clearfix mb-0"<a href="#">> -->
  <!-- <span class="float-m <a href="#">d-left d-block d-md-inline-block mt-25">
    COPYRIGHT &co<a href="#">py;  {{ year }}
    <a class="ml-<a href="#"> 25" href="https://ahasolar.in" target="_blank">AHA Solar</a>
    <span class="<a href="#"> d-none d-sm-inline-block">, All rights Reserved</span>
 <a href="#">  </span> -->
  <!-- <span class="float-md-right d-none d-md-block">Hand-crafted & Made with <span [data-feather]="'heart'" [class]="'pink'"></span> -->

<!--/ Footer -->

<ng-template #content let-modal>
  <div class="modal-content">
    <div class="modal-header">
   <!--<button type="button" class="close" data-dismiss="modal">&times;</button>-->
   <h4 class="modal-title text-danger">Important Notice !!!</h4>
   </div> 
   <div class="modal-body">
     <p class="text-success">Kindly Change Your Password !!!</p>
   </div>			
    <div class="modal-footer">
    <div class="text-center">
    <a  (click)="navigateToUrl()" class="btn btn-danger btn-sm"><strong>Click Here</strong></a></div>
   <!--<button type="button" class="btn btn-danger btn-sm" data-dismiss="modal"><strong>Close</strong></button>-->
   </div> 
 </div>
</ng-template>

<!-- Move <a href="#"> to top Button-->
<app-scroll-top class="scroll-top-button-container" *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>

<!-- Buynow Button-->
<!-- <div class="buy-now">
  <a href="https://1.envato.market/vuexy_admin" target="_blank" class="btn btn-danger" *ngIf="coreConfig.layout.buyNow"
    >Buy Now</a
  >
</div> -->
<div class="footer-main-container">
 <div class="footer-inner-container">
  <span>
    <img src="assets/images/footer-logo/footer-logo 1.png" alt="footer-logo" width="160px !important;">
  </span>
  
  <p>
    The website belongs to Ministry of New and Renewable Energy (MNRE), Government of India. 
    Content displayed are for reference purpose only.
     All efforts have been made to make the information as accurate as possible.
      MNRE will not responsible for any loss or harm,
       direct or consequential or any violation of law as that may be caused by inaccuracy in the information available on this website.
        Any discrepancy found may be brought to the notice of Ministry. The website is hosted by National Informatics Centre (NIC).
  </p>
 </div >
 <div class="footer-inner-container">
  <h3>Contact Us</h3>
  <p>Ministry of New and Renewable Energy, Atal Akshay Urja Bhawan,CGO Complex</p>
  <p>Lodhi Road, New Delhi-110 003, India.</p>
  <p><a href="www.mnre.gov.in">www.mnre.gov.in</a> </p>
 </div>
 <div class="footer-inner-container">
  <div class="inner-box">
  <h3>Useful Links</h3>
  </div>
  <div class="inner-box">

    <p><a href="https://solarrooftop.gov.in/" target="_blank"> National Portal for Rooftop Solar </a></p>
  <p><a href="https://ccdcwind.gov.in/" target="_blank"> CCDC Wind</a></p>
  <p><a href="https://akshayurja.gov.in/res/renw-all-india-cp" target="_blank"> Akshay Urja Portal</a></p>
  <p><a href="https://hrd.mnre.gov.in/" target="_blank"> HRD Portal  </a></p>
  <p><a href="https://biourja.mnre.gov.in/" target="_blank"> BioUrja Portal  </a></p>
  <p><a href="https://biogas.mnre.gov.in/" target="_blank"> Biogas Portal  </a></p>
  <!-- <p><a href="#" target="https://mnre.gov.in/"> Investment Portal  </a></p> -->
  <!-- <p><a href="http://fte.niftem.ac.in/" target="_blank"> R&D Food Processing  </a></p> -->
  <p><a href="https://rtionline.gov.in/" target="_blank"> RTI Portal  </a></p>
  <p><a href="https://legislative.gov.in/vidhi-sahitya/" target="_blank"> Vidhi Sahitya Prakashan  </a></p>
  </div>
  <div class="inner-box">
  <p><a href="http://goidirectory.gov.in/index.php" target="_blank"> GOI Directory  </a></p>
  <!-- <p><a href="https://powermin.nic.in/" target="_blank">Powermin.nic.in  </a></p> -->
  <p><a href="https://www.mygov.in/" target="_blank">Mygov.in  </a></p>
  <!-- <p><a href="https://gandhi.gov.in/" target="_blank">Gandhi.gov.in  </a></p> -->
  <!-- <p><a href="https://services.india.gov.in/" target="_blank">Services.india.gov.in  </a></p> -->
  <!-- <p><a href="http://tenders.gov.in/" target="_blank">Tenders of India  </a></p> -->
  <!-- <p><a href="http://districts.nic.in/" target="_blank">Districts of India  </a></p> -->
  <p><a href="http://www.nvsp.in/" target="_blank">Online Services for Voters  </a></p>
  <p><a href="http://www.makeinindia.com/home" target="_blank">Make in India  </a></p>
  <p><a href="https://www.india.gov.in/" target="_blank">Government of India  </a></p>
</div>
 </div>
 <div class="col-md-12 text-center">

  <!-- Links -->
  <small style="color:#ffffff; font-family:lato;">Total Hits : <span class="text-warning text-bold" id="totalHits">{{totalHit}}</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
        Total Visitors: <span class="text-warning text-bold" id="uniqueHits">{{totalVisitor}}</span></small>

</div>
</div>
